import { create } from "zustand";
import { toast } from "sonner";
import { devtools } from "zustand/middleware";
import http from "@/lib/http";

const useMarketTokenStore = create(
  devtools((set) => ({
    marketTokens: [],
    singleMarketToken: null,
    subTokens: [],
    loading: false,
    error: null,

    getMarketTokens: async ({ country, state, city }) => {
      set({ loading: true, error: null });

      const params = {
        ...(country ? { country } : {}),
        ...(state ? { state } : {}),
        ...(city ? { city } : {}),
      };

      try {
        const { data } = await http.get("/public/token", { params });
        set({
          marketTokens: data?.result || [],
          loading: false,
        });
        return data;
      } catch (error) {
        const errorMessage =
          error?.response?.data?.error || "Failed to fetch market tokens";
        set({ error: errorMessage, loading: false });
        toast.error(errorMessage);
      }
    },

    getSingleMarketToken: async (id) => {
      set({ loading: true, error: null });
    
      // Get the existing IDs from sessionStorage or initialize as an empty array
      const storedIds = JSON.parse(sessionStorage.getItem("marketTokenIds")) || [];
    
      // Check if the ID is already stored
      const isIdStored = storedIds.includes(id);
    
      // If the ID is already stored, return the boolean value
     
    
      try {
        const { data } = await http.get(`/public/token/${id}${!isIdStored ? "?increment=true" : ""}`);
        set({
          singleMarketToken: data?.token || null,
          subTokens: data?.subTokens || [],
          loading: false,
        });
    
        // Save the new ID to sessionStorage only once
        storedIds.push(id);
        sessionStorage.setItem("marketTokenIds", JSON.stringify(storedIds));
    
        return data;
      } catch (error) {
        const errorMessage =
          error?.response?.data?.error || "Failed to fetch token by ID";
        set({ error: errorMessage, loading: false });
        toast.error(errorMessage);
      }
    },
    
  })),
);

export default useMarketTokenStore;
